import { GroupLayout as GroupLayoutSchema, LayoutProps } from '@jsonforms/core'
import { withJsonFormsLayoutProps } from '@jsonforms/react'
import { MaterialLayoutRenderer } from '@jsonforms/material-renderers'
import { Card, CardContent, CardHeader, Typography } from '@mui/material'
import { isEmpty } from 'lodash'

const GroupLayout = ({
  uischema,
  schema,
  path,
  visible,
  enabled,
  renderers,
  cells,
  label,
}: LayoutProps) => {
  const groupLayout = uischema as GroupLayoutSchema
  const description: string | undefined =
    (groupLayout.options?.description as string) || schema?.description

  if (!visible) {
    return null
  }

  return (
    <Card sx={{ mt: '10px', mb: '10px' }}>
      {!isEmpty(label) && <CardHeader title={label} sx={{ pb: description ? 0 : undefined }} />}
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ px: 2, pb: 1 }}>
          {description}
        </Typography>
      )}
      <CardContent sx={{ pt: 1 }}>
        <MaterialLayoutRenderer
          schema={schema}
          path={path}
          visible={visible}
          enabled={enabled}
          direction="column"
          elements={groupLayout.elements}
          renderers={renderers}
          cells={cells}
        />
      </CardContent>
    </Card>
  )
}

export default withJsonFormsLayoutProps(GroupLayout)
